import { Icon } from '@branch-messenger/willow-ui'
import { Check, Menu01 } from '@branch-messenger/willow-ui/icons'
import { useMediaQuery } from '@uidotdev/usehooks'

import {
  DropdownMenu,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/dropdown-menu'
import { mediaQueries } from '@/styles/media'

import { useNavLinks } from '../hooks/useNavLinks'
import { NavMenuItem, NavMenuList } from '../styles'

export const NavMenu = () => {
  const isLargeTabletAndDown = useMediaQuery(mediaQueries.largeTabletAndDown)
  const navLinks = useNavLinks()

  if (!navLinks.length) {
    return null
  }

  if (isLargeTabletAndDown) {
    return (
      <DropdownMenu
        trigger={<DropdownMenuTrigger Icon={Menu01} />}
        showArrow={false}
      >
        {navLinks.map(({ label, ...menuItem }) => (
          <DropdownMenuItem
            key={label}
            showArrowRight={false}
            titleSize="xs"
            title={label}
            activeProps={{ iconRight: <Icon Icon={Check} /> }}
            {...menuItem}
          />
        ))}
      </DropdownMenu>
    )
  }

  return (
    <nav>
      <NavMenuList>
        {navLinks.map(({ label, ...navigationOptions }) => (
          <li key={label}>
            <NavMenuItem {...navigationOptions}>{label}</NavMenuItem>
          </li>
        ))}
      </NavMenuList>
    </nav>
  )
}
